import styled from '@emotion/styled';
import { pxToRem } from '@lbcamden/lib-react';

export const UserPinAuthRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  max-width: ${pxToRem(300)};
  padding: ${({ theme }) => theme.spacing([4, 0])};
`;
